import { Link } from 'react-router-dom';

const MARKETPLACE_URL = import.meta.env.VITE_MARKETPLACE_URL || 'https://aws.amazon.com/marketplace/search/results?searchTerms=PartnerBuddy';

export default function Header() {
  return (
    <header className="bg-white border-b border-pb-gray-100">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/">
          <img
            src="/partnerbuddy-logo.png"
            alt="PartnerBuddy"
            className="h-8"
          />
        </Link>
        <nav className="flex items-center gap-6">
          <Link to="/features" className="text-pb-gray-600 hover:text-pb-orange transition-colors">
            Features
          </Link>
          <Link to="/support" className="text-pb-gray-600 hover:text-pb-orange transition-colors">
            Support
          </Link>
          <a
            href={MARKETPLACE_URL}
            className="px-4 py-2 bg-pb-orange text-white rounded-lg font-medium hover:bg-pb-orange-dark hover:shadow-lg transition-all"
          >
            Get Started
          </a>
        </nav>
      </div>
    </header>
  );
}
